var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KlevuKMCSettings } from "../kmc.js";
export function getRedirects(term) {
    return __awaiter(this, void 0, void 0, function* () {
        const settings = yield KlevuKMCSettings();
        if (!settings.maps) {
            return [];
        }
        return settings.maps.klevu_keywordUrlMap.filter((map) => map.keywords.some((k) => k === term));
    });
}
